import * as actions from './actions'

const initialState = {
  messages: []
}

// Reducer
export const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case actions.FLASH_MESSAGE_ACTION_TYPE:
      throw new Error('redux-flash: missing middleware. Did you remember to add it when initializing your store?')
    case actions.ADD_MESSAGE_ACTION_TYPE: {
      const messages = [...state.messages, action.payload]
      return { ...state, messages }
    }
    case actions.REMOVE_MESSAGE_ACTION_TYPE: {
      const messages = state.messages.filter(m => m.id !== action.payload)
      return { ...state, messages }
    }
    case actions.CLEAR_MESSAGES_ACTION_TYPE:
      return { ...state, messages: [] }
    default:
      return state
  }
}

// Selectors
export const getFlashMessages = (state) => {
  if (!state.flash) throw new Error('redux-flash: state not found. Did you remember to attach the reducer at key `flash`?')
  return [...state.flash.messages]
}

export const getSuccessMessages = (state) => getFlashMessages(state).filter(m => !m.isError)
export const getErrorMessages = (state) => getFlashMessages(state).filter(m => m.isError)
export const getLatestMessage = (state) => getFlashMessages(state).pop()
